export default class Tabs {
  constructor() {
    this.$tabTitles = document.querySelectorAll('.js-tab-title');

    this.init();
  }

  init() {
    this.$tabTitles && this.$tabTitles.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        const $tab = e.target;

        if ($tab.classList.contains('active')) {
          return;
        }

        const $wrapper = $tab.closest('.js-tab-wrapper');
        const tabId = $tab.dataset.target;
        const $tabContent = $wrapper.querySelector(`${tabId}`);

        $wrapper.querySelectorAll('.js-tab-content').forEach((tabContent) => {
          tabContent.classList.remove('active');
        });

        $wrapper.querySelectorAll('.js-tab-title').forEach((tab) => {
          tab.classList.remove('active');
        });
        
        $tabContent.classList.add('active');
        $tab.classList.add('active');
      });
    });
  }
}


/** WEBPACK FOOTER **
 ** ./assets/js/modules/tabs.js
 **/